import React, { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import moment from 'moment';

import { Content } from 'api';
import { getProviderName, hasPhoto, isTextOnly, isUrl } from 'features/content/helpers';
import { getFullName } from 'helpers';
import { generateLink } from 'Links';

const MAX_BODY_LENGTH = 255;

interface IProps {
  content: Content;
}

const useStyles = makeStyles(theme => ({
  type: {
    color: theme.palette.primary.main,
  },
}));

const ContentResult: FC<IProps> = ({ content }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { groups, content_object, publish_at } = content;
  const { body, url_metadata } = content_object;

  const textOnly = isTextOnly(content);
  const photoOnly = hasPhoto(content);
  const hasUrl = isUrl(content);
  const creator = hasUrl ? getProviderName(content) : getFullName(content.user);

  function renderTitle() {
    if (textOnly) {
      return body || t('components:noTitle');
    }

    if (photoOnly) {
      return t('common:image');
    }

    if (hasUrl) {
      return url_metadata.title || t('components:noTitle');
    }

    return t('components:noTitle');
  }

  function renderGroups() {
    if (!groups || !groups.length) {
      return null;
    }

    return <span style={{ textTransform: 'uppercase' }}>{groups[0].title} / </span>;
  }

  return (
    <Fragment>
      <Typography variant="subtitle2" noWrap>
        <span className={classes.type}>{t('common:post')}: </span>
        <Link title={renderTitle()} component={generateLink(`/content/${content.content_id}`)}>
          {renderTitle()}
        </Link>
      </Typography>
      <Typography color="textSecondary">
        {renderGroups()}
        <span>{creator} / </span>
        <span>{moment.unix(publish_at).fromNow()}</span>
      </Typography>
      {!!url_metadata && <Typography>{url_metadata.description}</Typography>}
      {!url_metadata && !!body && <Typography>{body.substring(0, MAX_BODY_LENGTH)}</Typography>}
    </Fragment>
  );
};

export default ContentResult;
